import { useRecoilValue } from "recoil";

import mainStore from "src/stores/main";
import { BetTypeEnum } from "src/constants/enums/betType";
import { MainBetType } from "src/constants/types";
import { useTranslation } from "src/hooks/translation";

import { emptyStateMap } from "./constants";
import ProfitBoostInfo from "../profitBoostInfo";

import "./style.scss";

interface IProps {
	betType: MainBetType;
}

const EmptyState = ({ betType }: IProps) => {
	const t = useTranslation();
	const { profitBoostPercent } = useRecoilValue(mainStore);

	const { image, imageLight, text } = emptyStateMap[betType] || emptyStateMap[BetTypeEnum.Single];

	return (
		<div className="B-betslip-empty-state">
			{!!profitBoostPercent && <ProfitBoostInfo />}

			<img src={image} alt="empty state" className="B-empty-state-img" />
			<img src={imageLight} alt="empty state" className="B-empty-state-img-light" />

			<p>{t(text)}</p>
		</div>
	);
};

export default EmptyState;
